import React, { FC } from 'react';
import './ServiceCardSkeleton.scss';
import { CustomSkeletonElement } from '../CustomSkeletonElement';

interface ServiceCardSkeletonProps {
  canManage?: boolean;
}

const defaultProps = {
  canManage: true,
};

export const ServiceCardSkeleton: FC<ServiceCardSkeletonProps> = ({ canManage }) => {
  return (
    <div className="service-card-skeleton card card__primary">
      <div className="service-card-skeleton__container">
        <div className="service-card-skeleton__container__info">
          <div className="service-card-skeleton__container__info__header">
            <div className="service-card-skeleton__container__info__header__icon skeleton" />
            {canManage && (
              <CustomSkeletonElement
                skeletonContainerClassName="service-card-skeleton__container__info__header__buttons"
                skeletonChildrenClassName="service-card-skeleton__container__info__header__buttons__btn skeleton"
                childrenCount={3}
              />
            )}
          </div>
          <CustomSkeletonElement
            skeletonContainerClassName="service-card-skeleton__container__info__content"
            skeletonChildrenClassName="service-card-skeleton__container__info__content__line skeleton"
            childrenCount={3}
          />
        </div>
        <div className="service-card-skeleton__container__button skeleton" />
      </div>
      {canManage && (
        <CustomSkeletonElement
          skeletonContainerClassName="service-card-skeleton__manage"
          skeletonChildrenClassName="service-card-skeleton__manage__btn skeleton"
          childrenCount={3}
        />
      )}
    </div>
  );
};

ServiceCardSkeleton.defaultProps = defaultProps;
